export default "__VITE_ASSET__mcYqxL_q__"